{
  "close": "Close",
  "notifications": "Notifications",
  "countAnnouncement": "{count, plural, one {# notification} other {# notifications}}."
}
